import { calendarHeaderFiltersStateI, statusAppointment } from '@interfaces/calendar/calendar';
import { PractitionerOfficeI } from '@interfaces/practititoner/offices';
import { ServiceItemI } from '@interfaces/services/services';
import { DateRange } from '@modules/practitioner/calendar/calendar';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export const CalendarHeaderRe = createSlice({
    name: 'calendar-header',
    initialState: {
        viewFilter: "schedule", 
        statusFilter: "schedule",
        officeFilter: "schedule",
        serviceFilter: "schedule",
        date: "",
        dateRange: undefined
    } as calendarHeaderFiltersStateI,
    reducers: {
        setCalendarHeaderState: (state, action: PayloadAction<{viewFilter: 'week' | 'month' | 'day' | 'schedule', officeFilter: PractitionerOfficeI | "schedule", serviceFilter: ServiceItemI | "schedule", date:string, dateRange: DateRange | undefined}>) => {
            state.viewFilter = action.payload.viewFilter; 
            state.officeFilter = action.payload.officeFilter;
            state.serviceFilter = action.payload.serviceFilter;
            state.date = action.payload.date;
            state.dateRange = action.payload.dateRange;
        },
        setCalendarHeaderViewState: (state, action: PayloadAction<{viewFilter: 'week' | 'month' | 'day' | 'schedule'}>) => {
            state.viewFilter = action.payload.viewFilter; 
        },
        setCalendarHeaderStatusFilterState: (state, action: PayloadAction<{statusFilter: statusAppointment}>) => {
            state.statusFilter = action.payload.statusFilter; 
        }, 
        setCalendarHeaderOfficeFilterState: (state, action: PayloadAction<{officeFilter: PractitionerOfficeI | "schedule"}>) => {
            state.officeFilter = action.payload.officeFilter; 
        },
        setCalendarHeaderServiceFilterState: (state, action: PayloadAction<{serviceFilter: ServiceItemI | "schedule"}>) => {
            state.serviceFilter = action.payload.serviceFilter; 
        },
        setCalendarHeaderServiceDateState: (state, action: PayloadAction<{date: string}>) => {
            state.date = action.payload.date; 
        },
        cleanCalendarHeaderState: (state) => {
            state.viewFilter = 'schedule'; 
            state.officeFilter = "schedule";
            state.serviceFilter = "schedule";
            state.dateRange = undefined;
        }
    },
});

export const { setCalendarHeaderState, setCalendarHeaderViewState,setCalendarHeaderStatusFilterState, setCalendarHeaderOfficeFilterState, setCalendarHeaderServiceFilterState, setCalendarHeaderServiceDateState,cleanCalendarHeaderState } = CalendarHeaderRe.actions;
export default CalendarHeaderRe.reducer;
